/**
 * Sortiranje kolona tabele izveštaja: klik na zaglavlje menja smer, brojevi opadajuće, nazivi rastuće.
 * Redovi su objekti; `sort.key` je ime polja.
 */
export default {
  data: () => ({
    sort: { key: "total", dir: -1 },
  }),
  methods: {
    sortBy(key) {
      this.sort = {
        key,
        dir: this.sort.key === key ? -this.sort.dir : key === "name" ? 1 : -1,
      };
    },
    ariaSort(key) {
      if (this.sort.key !== key) {
        return null;
      }
      return this.sort.dir > 0 ? "ascending" : "descending";
    },
    sortArrow(key) {
      if (this.sort.key !== key) {
        return "";
      }
      return this.sort.dir > 0 ? "↑" : "↓";
    },
    sortRows(rows) {
      const { key, dir } = this.sort;
      return [...rows].sort((a, b) => {
        const first = a[key];
        const second = b[key];
        if (typeof first === "string" || typeof second === "string") {
          return String(first ?? "").localeCompare(String(second ?? ""), undefined, { sensitivity: "base" }) * dir;
        }
        return ((first || 0) - (second || 0)) * dir;
      });
    },
  },
};
